import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_authenticated/cases/$id/')({
    validateSearch: (search: Record<string, unknown>): { name?: string } => {
        return {
            name: typeof search.name === 'string' ? search.name : undefined
        }
    }
})
